import { CATEGORY_DESCRIPTION_SECTIONS } from '../../constants/sectionConfig';

export { SystemPrompts } from './SystemPrompts';
export { default as PromptsListComponent } from './PromptsListComponent';
export { default as PromptEditModal } from './PromptEditModal';

// Sub-features configuration for each feature
export const SUB_FEATURES_CONFIG: Record<string, string[]> = {
  chat: [], // No sub-features for chat
  social_media: [
    'facebook',
    'instagram',
    'linkedin',
    'twitter',
    'threads',
    'bluesky',
    'sms',
    'discord',
    'signal',
    'telegram',
  ],
  ad_generation: ['google_ads', 'facebook_ads', 'linkedin_ads'],
  newsletter: [],
  product_description: ['titles', 'meta', 'description', 'h1', 'brand', 'category'],
  category_description: Object.keys(CATEGORY_DESCRIPTION_SECTIONS),
};
